export const SPACING = {
  SMALL: 'py-1.5',
  MEDIUM: 'py-3.5',
  LARGE: 'py-6',
  RIGHT_SMALL: 'pr-10',
  RIGHT_LARGE: 'pr-16',
  LEFT_SMALL: 'pl-3',
  LEFT_LARGE: 'pl-6',
} as const;

export const COLORS = {
  GRAY_700: 'text-gray-700',
  WHITE_BG: 'bg-white',
  PRIMARY_BG: 'bg-blue-500',
  ERROR_TEXT: 'text-red-500',
} as const;

export const HEX_COLORS = {
  LIGHT_GRAY: '#f0f0f0',
  LIGHT_BLUE: '#d1e7ff',
  DARK_BLUE: '#0056b3',
  PRIMARY: '#3b82f6',
  SECONDARY: '#64748b',
  SUCCESS: '#22c55e',
  WARNING: '#f59e0b',
  ERROR: '#ef4444',
} as const;
